import React from 'react';

import { addStylesToSchema } from '@/exceed';
import { Form } from 'core/forms';

import styles from '../styles/initiativeWizardForm.module.scss';

const InitiativeWizardForm = ({
  model,
  onLoad,
  onUpdate,
  schema,
}) => (
  <div className={styles.element}>
    <Form
      model={model}
      onLoad={onLoad}
      onUpdate={onUpdate}
      schema={addStylesToSchema(schema, styles)}
    />
  </div>
);

export default React.memo(InitiativeWizardForm);
